module.exports = __webpack_public_path__ + "img/webeditor-technical-3.3acc7e6c.png";